$(function () {
    $(window).on("load scroll resize", function () {

        var st = $(window).scrollTop();
        var wh = $(window).height();

        $('.Tips .contents ul li').each(function (i) {
            var tg = $(this).offset().top;
            var id = $(this).attr('id');

            if (st > tg - wh + (wh / 2)) {
                $(".Tips .nav li").removeClass("active");
                $(".Tips .nav li a span").removeClass("m-number");
                var link = $(".Tips .nav li a[href *= " + id + "]");
                $(link).parent().addClass("active");
                $(link).children("span").addClass("m-number");
            }
        });

    });

});